/*
 *
 * MarketPage reducer
 *
 */

import MainActionTypes from 'containers/MainLayout/constants';
import { ActionTypes } from './constants';
import { ContainerState, ContainerActions, ProductWithLoading } from './types';

const loadingResources = Array(48)
  .fill(0)
  .map((_v, i) => ({ loading: true, id: i })) as unknown as ProductWithLoading[];

export const initialState: ContainerState = {
  search: {
    sort: [],
    filter: { preservation: 'All' },
    pagination: { page: 0, size: 40 },
  },
  result: {
    data: loadingResources,
    totalPage: 0,
    totalResults: 0,
    localLang: '',
    alternateLang: '',
  },
  description: {
    loading: false,
    id: 0,
    name: '',
    nameLocal: '',
  },
  noteItemLoading: false,
  kamereoProducts: [],
  suggestedProducts: [],
  aggregationData: {
    loading: true,
    subCategories: [],
    origins: [],
    brands: [],
  },
};

export default (state: ContainerState = initialState, action: ContainerActions) => {
  const { type, payload } = action as any;
  switch (type) {
    case ActionTypes.DEFAULT_ACTION:
      return state;

    case ActionTypes.SET_SEARCH:
      const searchPayload = JSON.parse(JSON.stringify(payload));
      if (searchPayload?.filter?.query && searchPayload?.filter?.categoryIds) {
        delete searchPayload?.filter?.categoryIds;
      }
      return { ...state, search: { ...searchPayload } };

    case ActionTypes.FETCH_PRODUCTS_REQUEST:
      return {
        ...state,
        result: { ...state.result, data: state.result.data?.map((item) => ({ ...item, loading: true })) },

        description: { ...state.description, loading: true },
      };

    case ActionTypes.FETCH_PRODUCTS_SUCCESS:
      return { ...state, ...payload };

    case ActionTypes.FETCH_DESCRIPTION_REQUEST:
      return { ...state, description: { ...state.description, loading: true } };

    case ActionTypes.FETCH_DESCRIPTION_SUCCESS:
      return { ...state, description: { ...payload, loading: false } };

    case MainActionTypes.FAVORITE_SUCCESS:
      const favoriteProducts = state.result.data.map((product) => {
        return product?.id === payload.id ? { ...product, isFavorite: payload.favorite } : product;
      });
      return { ...state, result: { ...state.result, data: favoriteProducts }, loading: false };

    case MainActionTypes.SET_PRODUCT_NOTE_REQUEST:
      return { ...state, noteItemLoading: true };

    case MainActionTypes.SET_PRODUCT_NOTE_SUCCESS:
      const updatedNoteProducts = state.result.data?.map((product) => {
        return product?.id === payload.id ? { ...product, note: payload.note } : product;
      });
      return { ...state, result: { ...state.result, data: updatedNoteProducts }, noteItemLoading: false };
    case MainActionTypes.SET_PRODUCT_NOTE_FAILURE:
      return { ...state, noteItemLoading: false };
    case ActionTypes.SET_KAMEREO_PRODUCTS:
      return { ...state, kamereoProducts: payload };
    case ActionTypes.SET_SUGGESTED_PRODUCTS:
      return { ...state, suggestedProducts: payload };
    case ActionTypes.SET_AGGREGATION_DATA:
      return {
        ...state,
        aggregationData: {
          ...state.aggregationData,
          ...payload,
        },
      };
    default:
      return state;
  }
};
